import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import RouteSeo from "@/components/Seo";
import Landing from "@/pages/Landing";
import AppShell from "@/pages/AppShell";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProposalView from "@/pages/ProposalView";
import PaymentReturn from "@/pages/PaymentReturn";
import PublicDocument from "@/pages/PublicDocument";
import ConnectReturn from "@/pages/ConnectReturn";

function App() {
  return (
    <HelmetProvider>
      <AppProvider>
        <BrowserRouter>
          <RouteSeo />
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/app" element={<AppShell />} />
              <Route path="/app/:view" element={<AppShell />} />
              <Route path="/app/service/:slug" element={<AppShell />} />
              <Route path="/app/workspace/:wid" element={<AppShell />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/proposal/:id" element={<ProposalView />} />
              <Route path="/doc/:pubId" element={<PublicDocument />} />
              <Route path="/payment/:outcome" element={<PaymentReturn />} />
              <Route path="/connect/:outcome" element={<ConnectReturn />} />
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors />
      </AppProvider>
    </HelmetProvider>
  );
}

export default App;
